import { userApi } from "../../config";

export async function forgotPasswordApi(email: string, resetType: string) {
    try {
        if (resetType !== "reset-password" && resetType !== "reset-instructor-password") {
            return { success: false, message: "Invalid reset type" };
        }
        const response = await userApi.post('/forgot-password', { email, resetType });
        return response.data;
    } catch (err: any) {
        return { success: false, message: err.response?.data?.message || "An error occurred" };
    }
}

export async function resetPasswordApi(newPassword: string, resetToken: string) {
    try {
        const response = await userApi.put('/reset-password', { newPassword: btoa(btoa(newPassword)) }, { headers: { Authorization: `Bearer ${resetToken}` } });
        return response.data;
    } catch (err: any) {
        return { success: false, message: err.response?.data?.message || "An error occurred" };
    }
}